import {Swiper} from 'swiper';

export class ProductImagesThumbs {
	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	private sliderSettings = () => ({
		loop: true,
		direction: 'vertical',
		slidesPerView: 'auto',
	});
	public slider: Swiper;

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.sliderElement = this.element.querySelector('.product-images-thumbs__slider');

		this.init();
	}

	public init = ():void => {
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
	};
}
